import React, { Component, useState } from "react";
import Modal from "react-bootstrap/Modal";
import OTPInput, { ResendOTP } from "otp-input-react";

const OtpPopup = (props) => {
  return (
    <Modal {...props} className="otp-popup" aria-labelledby="contained-modal-title-vcenter" centered>
      <section className="otp-modal">
        <a onClick={props.otp_closeBtn} className="close-icon" href="javascript:;">
          &nbsp;
        </a>
        <Modal.Body>
          <section className="otp-sec">
            <h1>
              Verify Your Email ID{" "}
              <span>
                We've just emailed you a <strong>Verification code</strong> to your Email ID. Kindly Input below.
              </span>
            </h1>
            <section className="otp-fields">
              <OTPInput value={props.state.otp} onChange={(e) => props.otpOnChange(e)} autoFocus OTPLength={6} otpType="number" inputClassName="input-field" placeholder={"******"} />
            </section>
            <aside className="cmx-flex-btn-group text-center">
              <a onClick={props.otp_submitBtn} className={`flex-btn ${props.otpSubmitDisabled() ? "" : "disabled"}`} href="javascript:;" title="SUBMIT">
                <span>submit</span>
              </a>
            </aside>

            <aside className="resend">
              <p>
                Didn't Receive?{" "}
                <a onClick={props.otp_resendBtn} href="javascript:;" title="RESEND CODE">
                  RESEND CODE
                </a>
              </p>
            </aside>
          </section>
        </Modal.Body>
      </section>
    </Modal>
  );
};

export default OtpPopup;
